/**
 * Created by razial on 05.06.2026.
 */

class TooltipComponent extends BaseComponent {
    onCreate() {
        this.enabled = false;
    }

    setEnabled(enabled) {
        if (this.enabled === enabled) {
            return;
        }
        this.enabled = enabled;

        if (enabled) {
            const options = PrefabBuilder.resolveProperty(this.options.options, this.context);
            cleverapps.tooltipManager.create(this.node, options);
        } else {
            cleverapps.tooltipManager.remove(this.node);
        }
    }
}

Prefab.registerComponent("TooltipComponent", TooltipComponent);
